import React, { useState, useEffect } from "react";
import pharmacies, { groupId } from './pharmacies';
const token = localStorage.getItem("authToken");

const StockExcess = () => {
  const [viewOption, setViewOption] = useState("By drug");
  const [selectedPharmacy, setSelectedPharmacy] = useState("");
  const [inventoryData, setInventoryData] = useState([]);
  const [totals, setTotals] = useState({ totalValue: 0, totalPackets: 0 });
  const [usageDataMap, setUsageDataMap] = useState({});
  const [returnToWarehouse, setReturnToWarehouse] = useState({});
  const [displayRTWOnly, setDisplayRTWOnly] = useState(false);
  const [excessValueLimit, setExcessValueLimit] = useState("");

  useEffect(() => {
    const fetchInventoryData = async () => {
      if (!groupId) return;
      try {
        const response = await fetch(`https://api.pharmacegroup.co.uk/ggetInventory?groupId=${groupId}`);
        const data = await response.json();
        setInventoryData(data);
        const totalValue = data.reduce((acc, item) => acc + (item.price * (parseInt(item.numberpackets, 10) || 0)), 0);
        const totalPackets = data.reduce((acc, item) => acc + (parseInt(item.numberpackets, 10) || 0), 0);
        setTotals({ totalValue, totalPackets });
      //  fetchAllUsageData(data);
      } catch (error) {
        console.error("Error fetching inventory data:", error);
      }
    };

    fetchInventoryData();
  }, []);

  const fetchUsageData = async (pharmacyId, snmed) => {
    try {
      const response = await fetch(`https://api.pharmacegroup.co.uk/getusage?pharmacyId=${pharmacyId}&snowmed=${encodeURIComponent(snmed)}`);
      const data = await response.json();

      // Ensure data is an array and has at least one entry
      if (Array.isArray(data) && data.length > 0) {
          return {
              qty_used: data[0].qty_used || 0,
              created: data[0].created || null
          };
      }

      // Return default values if no data is found
      return { qty_used: 0, created: null };
  } catch (error) {
      console.error(`Error fetching usage data for ${pharmacyId}, ${snmed}:`, error);
      return { qty_used: 0, created: null };
  }
  };

  const fetchAllUsageData = async (data) => {
    const usageMap = {};
    const fetchPromises = [];

 data.forEach((item) => {
    const key = `${item.pharmacyId}-${item.vmppid}`;
    if (!usageMap[key]) {
        fetchPromises.push(
            fetchUsageData(item.pharmacyId, "SC-" + item.vmppid).then((usage) => {
                usageMap[key] = {
                    qty_used: usage.qty_used, 
                    created: usage.created 
                };
            })
        );
    }
});


    await Promise.all(fetchPromises);
    setUsageDataMap(usageMap);
  };

  const filterData = () => {
    return inventoryData.filter((item) => selectedPharmacy ? item.pharmacyName === selectedPharmacy : true);
  };

  const groupByDrug = () => {
    const filteredData = filterData();
    const groupedData = filteredData.reduce((acc, item) => {
      if (!acc[item.pharmacyName]) acc[item.pharmacyName] = {};
      if (!acc[item.pharmacyName][item.vmppNm]) {
        acc[item.pharmacyName][item.vmppNm] = {
          totalPrice: 0,
          totalPackets: 0,
          usage3mths: 0,
          pharmacyId: item.pharmacyId,
        };
      }
      acc[item.pharmacyName][item.vmppNm].totalPrice += item.price;
      acc[item.pharmacyName][item.vmppNm].totalPackets += parseInt(item.numberpackets, 10) || 0;
      return acc;
    }, {});

    const result = [];
    for (const pharmacy in groupedData) {
      for (const drug in groupedData[pharmacy]) {
        const drugData = groupedData[pharmacy][drug];
        const key = `${drugData.pharmacyId}-${drug}`;
        const usage3mths = usageDataMap[key] || 0;
        const totalValue = drugData.totalPackets * drugData.totalPrice;
        const excessDeficitNumber = drugData.totalPackets - usage3mths;
        const excessDeficitValue = excessDeficitNumber * drugData.totalPrice;

        result.push({
          pharmacyName: pharmacy,
          drugName: drug,
          ...drugData,
          usage3mths,
          totalValue,
          excessDeficitNumber,
          excessDeficitValue,
        });
      }
    }

    return result;
  };

  let displayData = viewOption === "By drug" ? groupByDrug() : filterData();

  if (displayRTWOnly) {
    displayData = displayData.filter(item => returnToWarehouse[item.drugName] > 0);
  }

  if (excessValueLimit) {
    displayData = displayData.filter(item => item.excessDeficitValue > excessValueLimit);
  }

  const handleRTWChange = (drugName, value) => {
    setReturnToWarehouse(prev => ({ ...prev, [drugName]: value }));
  };

  const handleTransferToWarehouse = () => {
    const updatedRTW = {};
    displayData.forEach(item => {
      if (item.excessDeficitNumber > 0) {
        updatedRTW[item.drugName] = item.excessDeficitNumber;
      }
    });
    setReturnToWarehouse(updatedRTW);
  };

  return (
    <div>
      <h1>Stock - Excess</h1>

      <div style={{ marginBottom: "20px" }}>
       <label>Pharmacy:</label>
    <select style={{ fontSize: "10px", padding: "1px 3px", width: "90px" }} value={selectedPharmacy} onChange={(e) => setSelectedPharmacy(e.target.value)}>
      <option value="">All</option>
      {(JSON.parse(localStorage.getItem("members") || "[]") || []).map((m, i) => (
        <option key={i} value={m.pharmacyName}>{m.pharmacyName}</option>
      ))}
    </select>
        <input
          type="number"
          placeholder="Limit to excess >"
          value={excessValueLimit}
          onChange={(e) => setExcessValueLimit(e.target.value)}
          style={{ marginLeft: "10px" }}
        />
        <label style={{ marginLeft: "10px" }}>
          <input
            type="checkbox"
            checked={displayRTWOnly}
            onChange={() => setDisplayRTWOnly(!displayRTWOnly)}
          /> Display RTW only
        </label>
        <button onClick={handleTransferToWarehouse} style={{ marginLeft: "10px" }}>
          Transfer excess stock to warehouse
        </button>
      </div>

      {displayData.length > 0 && (
        <table border="1" cellPadding="10" style={{ marginTop: "20px", tableLayout: "auto" }}>
          <thead>
            <tr>
              <th>Pharmacy Name</th>
              <th>Drug</th>
              <th>No. Packets</th>
              <th>Value</th>
              <th>3mth Usage</th>
              <th>Excess/Deficit Number</th>
              <th>Excess/Deficit Value</th>
              <th>No. to return to warehouse</th>
            </tr>
          </thead>
          <tbody>
            {displayData.map((item, index) => (
              <tr key={index}>
                <td>{item.pharmacyName}</td>
                <td>{item.drugName}</td>
                <td>{item.totalPackets}</td>
                <td>{item.totalValue.toFixed(2)}</td>
                <td>{item.usage3mths}</td>
                <td>{item.excessDeficitNumber}</td>
                <td>{item.excessDeficitValue.toFixed(2)}</td>
                <td>
                  <select
                    value={returnToWarehouse[item.drugName] || ""}
                    onChange={(e) => handleRTWChange(item.drugName, parseInt(e.target.value, 10))}
                  >
                    <option value="">Select</option>
                    {[...Array(20)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>{i + 1}</option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default StockExcess;
